import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Topbar from "../../scenes/global/Topbar";
import GyaaniSidenav from "./components/Sidenav/GyaaniSidenav";
import Gyaanidashboard from "./components/Dashboard/Gyaanidashboard";
import { Outlet } from "react-router-dom";
import "../../styles/moduleBackgrounds.css"; 



import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "../../theme";

function GyaaniApp() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [role, setRole] = useState(null);
  const [clientcode, setClientCode] = useState(null);

  useEffect(()=>{
    const storedRole = localStorage.getItem("role");
    const clientCode = localStorage.getItem("clientCode");

    setRole(storedRole)
    setClientCode(clientCode)

  })

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app module-Main-DashboardGyanni">
          {(role === "Super Admin" || role === "SuperAdmin" || role === "admin" || role === "Admin" || clientcode == "stupa") && (
          <GyaaniSidenav isSidebar={isSidebar} />
          )}
          <main className="content height100">
            {/* <Topbar setIsSidebar={setIsSidebar} /> */}
            <Routes>
              <Route path="/" element={<Gyaanidashboard />} />
            
            </Routes>
             {/* Using Outlet to render child routes */}
             <Outlet />
      
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default GyaaniApp;
